import type { ComponentType } from 'react';

import type { EntryPoint } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import type { AppSwitcherContentEntryPointProps } from './app-switcher-content';

type AppSwitcherContentEntryPointComponent = ComponentType<AppSwitcherContentEntryPointProps>;

/**
 * A platform-owned, zero-query entry point for AppSwitcher panel content.
 *
 * GTN owns the uniform Switcher providers, so this boundary defers their code
 * with the content while the eager trigger separately invokes `prefetchAll`
 * for interaction-time data and bundle preloading.
 */
export const appSwitcherContentEntryPoint: EntryPoint<
	AppSwitcherContentEntryPointComponent,
	Record<string, never>
> = createEntryPoint({
	root: JSResourceForInteraction<AppSwitcherContentEntryPointComponent>(() => import(/* webpackChunkName: "async-navigation-global-top-navigation-app-switcher-content" */ "./app-switcher-content"), { moduleId: "7be66bbf", modulePath: "../platform/packages/navigation/global-top-navigation/src/ui/app-switcher/app-switcher-content.tsx", priority: "interaction", moduleId: 'navigation.global-top-navigation.app-switcher-content',
		}),
	getPreloadProps: () => ({}),
});
